import { render } from "./GoalsAndBudgetTips.vue?vue&type=template&id=b35edcf6"
import script from "./GoalsAndBudgetTips.vue?vue&type=script&lang=js"
export * from "./GoalsAndBudgetTips.vue?vue&type=script&lang=js"

import "./GoalsAndBudgetTips.vue?vue&type=style&index=0&id=b35edcf6&lang=scss"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__